import React from 'react';
import { CloseIcon, PencilIcon, ArrowRightWhiteIcon } from '../icons';

interface PreviewMessageModalProps {
    isOpen: boolean;
    onClose: () => void;
    onEdit: () => void;
    onSend: (emailData: {
        subject: string;
        content: string;
        techId: string;
        researcherName: string;
    }) => void;
    techId: string;
    referenceNumber?: string; // For display purposes in subject line
    techManagerName: string; // Changed from researcherName to techManagerName
    techTitle: string;
    message: string;
    summary: string;
    userName: string;
}

export const PreviewMessageModal: React.FC<PreviewMessageModalProps> = ({
    isOpen,
    onClose,
    onEdit,
    onSend,
    techId,
    referenceNumber,
    techManagerName,
    techTitle,
    message,
    summary,
    userName,
}) => {
    if (!isOpen) return null;

    const handleSend = () => {
        // Use referenceNumber for display, fallback to techId if not available
        const displayId = referenceNumber || techId;
        const subject = `Interest in tech (${displayId})`;
        const content = message; // The full message content from ContactUniversityModal
        
        onSend({
            subject,
            content,
            techId, // Keep techId for backend processing
            researcherName: techManagerName // Use techManagerName for email sending
        });
    };

    return (
        <div className="fixed inset-0 w-full h-full flex justify-center items-center bg-black/70 backdrop-blur-sm z-50 p-4 font-grotesk">
            <div className="relative w-[690px] max-h-[90vh] bg-white rounded-2xl flex flex-col items-center">
                 <div className="absolute top-0 right-0 pt-6 pr-6">
                    <button onClick={onClose} className="flex p-2.5 justify-center items-center gap-2 rounded-full bg-grayscale-1200 shadow-custom-light">
                        <CloseIcon />
                    </button>
                 </div>
                 
                 <div className="p-6 w-full flex-1 overflow-y-auto hide-scrollbar flex flex-col gap-4">
                    <h2 className="text-grayscale-1300 font-grotesk text-base font-medium">Preview</h2>

                    <div className="flex-1 flex flex-col gap-4">
                        <div className="flex items-center gap-2 py-2">
                            <span className="text-[#7A7A7A] font-grotesk text-xs">Subject:</span>
                            <span className="text-grayscale-1300 font-grotesk text-sm">Interest in tech ({referenceNumber || techId})</span>
                        </div>
                        <div className="flex items-center gap-2 py-2">
                            <span className="text-[#7A7A7A] font-grotesk text-xs">Dear:</span>
                            <span className="text-grayscale-1300 font-grotesk text-sm">{techManagerName}</span>
                        </div>
                        <div className="flex flex-col gap-4">
                            <p className="text-grayscale-1300 font-grotesk text-sm leading-6 whitespace-pre-wrap">
                                {message}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="w-full p-6 pt-0 flex items-center gap-4">
                    <button onClick={onEdit} className="flex p-3 justify-center items-center gap-2 rounded-full border border-[#323232] bg-white shadow-custom-light">
                        <PencilIcon />
                    </button>
                     <button onClick={handleSend} className="flex py-2.5 px-4 justify-center items-center gap-2 flex-1 rounded-full bg-primary-500 shadow-custom-light">
                        <span className="text-white text-center font-grotesk text-sm font-medium">Send Message</span>
                        <ArrowRightWhiteIcon />
                    </button>
                </div>
            </div>
        </div>
    );
};